import{useRef as r}from"react";var t=()=>{const t=r(!0);return t.current?(t.current=!1,!0):t.current};export{t as useFirstMountState};
//# sourceMappingURL=useFirstMountState.js.map